/* eslint-disable @next/next/no-img-element */
/* eslint-disable react/no-unescaped-entities */
// @ts-nocheck
import { CardEndorsWhatis, CardPackage, CardPointToPoint, CardRecognitions, CardTematicStudioBox, CardWhatTheySay, CardWithDescription, CenteredRadiantGradient, MetaData, PackageSwiper, StyledButton } from '@/components/atoms'
import route_list from '@/constant/routeUrl'
import { useRouter } from 'next/router'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import Image from 'next/image'
import { background_list, icon_list } from '@/assets/images'
import { useRef, useEffect } from 'react'
import { TematicStudioBox, TitleImageDescSection } from '@/components/molecules'
import app_config from '@/constant/config'
import { getSeoMetadata } from '@/utility/apiProcess/seo/server'

const LiveShoppingExperience = (props) => {
	const { t } = useTranslation('endorsement')
	const router = useRouter()
  const what_is_data = [
    {
      title: t('endorsement.whatis'),
      description:  t('endorsement.whatis_desc'),
    },
    {
      title: t('endorsement.why'),
      description: t('endorsement.why_desc'),
    },
  ]

  const swiperData2 = [
    {
      title: "Social Media Management",
      onClick: () => router.push(route_list.social_media_management),
      buttonLabel: "Learn More →",
    },
    {
      title: "Live Shopping",
      onClick: () => router.push(route_list.live_shopping),
      buttonLabel: "Learn More →",
    },
    {
      title: "Enterprise Solution",
      onClick: () => router.push('https://sbe.socialbread.id/'),
      buttonLabel: "Learn More →",
    },
  ]

  const swiperTestimony = [
    {
      description: `"${t('endorsement.testimoni1')}"`,
      photo: background_list.raga,
      name: "Raga Hariawan",
      position: "Senior Content Specialist @ Bukalapak"
    },
    {
      description: `"${t('endorsement.testimoni1')}"`,
      photo: background_list.vicky,
      name: "Vicky Kurniawan",
      position: "Founder @ Kibocheese"
    },
  ]

  const stepData = [
    {
      title: t('endorsement.hiw_1'),
      description: t('endorsement.hiw_1_desc'),
    },
    {
      title: t('endorsement.hiw_2'),
      description: t('endorsement.hiw_2_desc'),
    },
    {
      title: t('endorsement.hiw_3'),
      description: t('endorsement.hiw_3_desc'),
    },
    {
      title: t('endorsement.hiw_4'),
      description: t('endorsement.hiw_4_desc'),
    }
  ]

  const howAreWeData = {
    title: t('endorsement.haw'),
    description: t('endorsement.haw_desc'),
    image: background_list.endorsementbg,
    points: [
      {
        title: t('endorsement.haw1'),
        description: t('endorsement.haw1_desc')
      },
      {
        title: t('endorsement.haw2'),
        description: t('endorsement.haw2_desc')
      },
      {
        title: t('endorsement.haw3'),
        description: t('endorsement.haw3_desc')
      },
      {
        title: t('endorsement.haw4'),
        description: t('endorsement.haw4_desc')
      },
    ]
  }

	return (
		<div className='tw-bg-gradient-to-r tw-from-dark-green tw-to-light-green tw-w-full'>
      <MetaData title={props.seoMetadata.title} ogImage="https://i.ibb.co/bzC5z1g/socialbreadlogo.jpg" ogTitle={props.seoMetadata.title} keywords={props.seoMetadata.keywords} ogDescription={props.seoMetadata.description} />
			<div className='tw-newsroom-banner' id='newsroom-banner'>
				<div className='tw-m-auto md:tw-py-16 tw-py-8 md:tw-px-0 tw-px-4 tw-max-w-6xl tw-mx-auto tw-grid md:tw-grid-cols-2 tw-gap-2'>
					<div>
            <h2 className='tw-text-white md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 md:tw-text-left tw-text-center'>
              {t('endorsement.title')}
            </h2>
            <span className='tw-text-white tw-text-sm md:tw-text-justify tw-flex tw-text-center'>
              {t('endorsement.desc')}
            </span>
            <div className='md:tw-flex tw-hidden tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton onClick={() => window.open(app_config.AndroidClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.playstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
              <StyledButton onClick={() => window.open(app_config.AppstoreClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.appstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
            </div>
          </div>
          <div className='tw:w-full tw-flex tw-flex-col tw-items-center tw-justify-center'>
            <Image src={background_list.endorsement} alt='' className='md:tw-w-[60%] tw-w-[50%]' />
            <div className='md:tw-hidden tw-flex tw-items-end tw-flex-row tw-gap-2 tw-mt-5'>
              <StyledButton onClick={() => window.open(app_config.AndroidClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.playstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
              <StyledButton onClick={() => window.open(app_config.AppstoreClientAppUrl)} className=''>
                <Image
                  alt=''
                  src={icon_list.appstore_logo}
                  className='tw-cursor-pointer tw-h-12 tw-w-[150px]'
                />
              </StyledButton>
            </div>
          </div>
				</div>
			</div> 
			<div className='tw-w-full tw-min-h-[500px] tw-flex tw-items-center tw-justify-center tw-flex-col tw-bg-[#F1F1F1] md:tw-rounded-[40px] tw-rounded-[20px] tw-overflow-hidden'>
				<div className='tw-newsroom-container'>
					<div className='tw-max-w-6xl tw-mx-auto tw-my-8 md:tw-px-0 tw-px-4 tw-text-justify'>
            {/* What is */}
            <CardEndorsWhatis data={what_is_data} />
            {/* How It Works */}
            <div className='tw-my-32'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-5 tw-mt-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left tw-w-fit tw-pb-1'>{t('endorsement.hiw')}</h1>
              <p className='tw-text-left tw-mb-5'>
                {t('endorsement.hiw_desc')}
              </p>
              <div className="tw-flex tw-items-center tw-font-poppins tw-rounded-lg ">
                <div className="tw-justify-center tw-flex-1 tw-max-w-6xl">
                  <CardPointToPoint data={stepData} className='md:tw-grid-cols-4' />
                </div>
              </div>
            </div>
            {/* How are we different? */}
            <TitleImageDescSection data={howAreWeData}/>
            {/* Our Packag1 */}
            <div className='tw-w-full tw-rounded-2xl tw-relative tw-overflow-hidden tw-grid md:tw-grid-cols-3  md:tw-py-14 tw-py-5 md:tw-px-20 tw-px-5'>
              <Image src={background_list.card_wave_green_big} alt="arrow rotate" className='tw-absolute tw-top-0 tw-right-0 tw-z-0 tw-h-full' />
              <div className='tw-z-10 md:tw-col-span-2 '>
                <h2 className='tw-text-white md:tw-text-6xl tw-text-2xl tw-mb-10 tw-font-semibold md:tw-text-left tw-text-center'>
                  {t('endorsement.lvlup')}
                </h2>
                <span className='tw-text-white md:tw-text-xl tw-text-md tw-text-center'>{t('endorsement.lvlup_desc')}</span>
              </div>
              <div className='tw-w-full tw-items-center tw-justify-center tw-z-10 tw-flex tw-flex-col'>
                <Image src={background_list.endorse_selfie } alt='' className='md:tw-block tw-hidden' />
                <StyledButton
                  title={t('endorsement.talk')}
                  className='tw-text-white tw-mt-5 tw-font-semibold md:tw-text-xl tw-text-xs tw-items-center tw-border-2 tw-border-white md:tw-px-6 tw-px-5 md:tw-py-2 tw-py-3 tw-rounded-full tw-justify-center md:tw-flex'
                  onClick={() => window.open(app_config.whatsappTemplate)}
                />
              </div>
            </div>
            {/* What They Say */}
            <div className='tw-my-20'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-left tw-pb-1'>{t('endorsement.what_they')}</h1>
              <CardWhatTheySay data={swiperTestimony}/>
            </div>
            {/* Other Services */}
            <div className=' tw-mb-12'>
              <h1 className='md:tw-text-5xl tw-text-2xl tw-font-semibold tw-mb-10 tw-text-transparent tw-bg-clip-text tw-bg-gradient-to-r tw-from-dark-green tw-from-40% tw-to-light-green tw-to-60% tw-text-center tw-pb-1'>{t('endorsement.other')}</h1>
              <div className='tw-relative'>
                <CenteredRadiantGradient />
                <div className='md:tw-block tw-hidden'>
                  <PackageSwiper data={swiperData2}  titleClass="tw-text-left tw-my-0 tw-px-20" devide={false} />
                </div>
                <div className='tw-block md:tw-hidden'>
                  <CardPackage data={swiperData2} cardClass="tw-min-h-[250px] tw-p-10" devide={false}/>
                </div>
              </div>
            </div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default LiveShoppingExperience

export async function getStaticProps() {
  const locale = 'id'
  let seoMetadata = { data: { result: {} } }
  try {
    seoMetadata = await getSeoMetadata({category_slug: 'pages', names: 'endorsement'})
  } catch (err) {
    console.error('[getStaticProps] getSeoMetadata failed at build time, falling back to {}', err)
  }

  return {
		props: {
      seoMetadata: seoMetadata.data.result || {},
			...(await serverSideTranslations(locale, ['footer', 'navbar', 'privacy-policy'])),
		},
	}
}
